import './UsersPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { routerActions } from 'react-router-redux';

import CreateMenu from 'components/CreateMenu';
import LoadingSpinner from 'components/LoadingSpinner';
import Tab from 'components/Tab';

import { closeModal, openModal } from 'containers/App/store/actions';
import { clearGroup } from './store/groups/actions';
import { clearUser } from './store/users/actions';
import { updateTitle } from 'containers/App/store/actions';

import { MODALS } from 'utils/constants';

class UsersPage extends React.Component {
    componentWillMount() {
        this.props.updateTitle('Users');

        this.tabs = [
            {
                url: '/users/individuals',
                text: 'Individuals'
            }, {
                url: '/users/groups',
                text: 'Groups'
            }
        ];

        this.createMenuLinks = [
            {
                icon: 'individual',
                mobileLinkUrlString: '/users/individuals',
                onClick: this.openNewModal.bind(this, MODALS.USER_EDIT),
                text: 'Individual'
            }, {
                icon: 'groups',
                mobileLinkUrlString: '/users/groups',
                onClick: this.openNewModal.bind(this, MODALS.GROUP_EDIT),
                text: 'Group'
            }, {
                icon: 'upload',
                mobileLinkUrlString: '/users/individuals',
                onClick: this.openNewModal.bind(this, MODALS.USER_IMPORT),
                text: 'Bulk User Import'
            }
        ]
    }

    openNewModal(type) {
        if(type === MODALS.USER_EDIT || type === MODALS.USER_IMPORT) {
            this.props.clearUser();
            this.props.changeLocation('/users/individuals');
        } else if(type === MODALS.GROUP_EDIT) {
            this.props.clearGroup();
            this.props.changeLocation('/users/groups');
        }

        this.props.openModal(type);
    }

    render() {
        return (
            <div>
                <nav className="tabs">
                    {this.tabs.map((tab, index) => {
                        return (
                            <Tab to={tab.url}
                                 className={classNames({'active-tab': tab.url === location.pathname})}
                                 key={index}>
                                {tab.text}
                            </Tab>
                        )
                    })}
                </nav>

                {/* User query requires role, so delaying query getUsers query until done */}
                {this.props.auth.role == null ? <LoadingSpinner /> : this.props.children}

                <CreateMenu links={this.createMenuLinks} />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (locationString) => dispatch(routerActions.push(locationString)),
        clearGroup: () => dispatch(clearGroup()),
        clearUser: () => dispatch(clearUser()),
        closeModal: () => dispatch(closeModal()),
        openModal: (modalString) => dispatch(openModal(modalString)),
        updateTitle: (title) => dispatch(updateTitle(title))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersPage);



// WEBPACK FOOTER //
// ./src/containers/UsersPage/index.js